import React from "react";
import Grid from "@material-ui/core/Grid";
import '../../../App.scss';
import EmptyWoodButton from "../../../assets/images/empty_wood_btn.png";
import EmptyWood from "../../../assets/images/empty_wood.png";
import UserScoreBackground from "../../../assets/images/img_woodi.png";
import Star from "../../../assets/images/state_star.png";
import UserProfileHolder from "../../../assets/images/ic_rand_empty_wood.png";

class UserRank extends React.Component {
    constructor() {
        super();
        this.state = {
        }
    }
    render() {
        const{
            avatar,
            gift,
            id,
            name,
            point,
            pos,
            self}=this.props.data
        return (
            <Grid item  direction={"column"} sm={12} xs={12} alignItems='center' justify={'center'} container
            style={{
                backgroundImage:"url(" + EmptyWoodButton + ")",
                backgroundSize: '100% 100%',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: '100%',
                // height:'200px'
            }}>
                    <Grid container justify='space-around' alignItems='center' style={{
                        marginTop:'20px'}}>
                        <Grid container sm={7} direction={"row"}  xs={7} alignItems='center' justify='center' style={{
                            position:'relative',
                            backgroundImage:`url(${UserScoreBackground})`,
                            backgroundSize:'contain',
                            backgroundRepeat:'no-repeat',
                            backgroundPosition: '50% 50%',
                        }}>
                            <Grid xs={10} sm={10} direction={"column"} container  alignItems={"center"} justify='center'>
                                <Grid container style={{transform:'translateY(30%)'}}  alignItems={"center"} justify='center'>
                                    <p>
                                        {name}
                                    </p>
                                </Grid>
                                <Grid container direction={"row-reverse"}  alignItems={"center"} justify='center' style={{transform:'translateY(-30%)'}}>
                                    <Grid item container style={{color:'yellow'}} justify={"center"} alignItems={"center"} xs={1} sm={1}>
                                        <p>
                                            {point}
                                        </p>
                                    </Grid>
                                    <Grid item container justify={"center"} alignItems={"center"} xs={1} sm={1}>
                                        <img src={Star} style={{width:'80%'}} alt=""/>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid style={{backgroundColor:'blue',position:'relative'}} xs={2} sm={2} container  alignItems={"center"} justify='center'>
                                <img style={{width:'150%',position:'absolute'}} src={UserProfileHolder} alt=""/>
                                <img style={{width:'120%',position:'absolute'}} src={avatar} alt=""/>
                            </Grid>
                           </Grid>
                        <Grid sm={3}  xs={3} container  alignItems='center' justify='space-around'>
                            <Grid item style={{position:'relative'}} sm={6} xs={6} container alignItems={"center"} justify={"center"}>
                                <img style={{width:'100%'}} src={EmptyWood} alt=""/>
                                <p style={{color:'yellow',position:'absolute'}}>
                                    {pos}
                                </p>
                            </Grid>
                            <Grid item sm={6} xs={6} container alignItems={"center"} justify={"center"}>
                                <p style={{ transform:'rotate(90deg)',color:'#ffffff',textAlign:'center'}}>
                                    رتبه شما
                                </p>
                            </Grid>

                        </Grid>
                    </Grid>
                    <Grid>
                        <p style={{ color:'#ffffff',padding:'0px 10px 30px 10px',textAlign:'center',direction:'rtl',margin:'0'}}>
                            جوایز پس از اتمام لیگ در صورتی که جز برندگان باشید به کیف پول شما اضافه خواهد شد.
                        </p>
                    </Grid>
            </Grid>
        )
    }
}
export default UserRank